// central store
import Vue from 'vue';
import Vuex from 'vuex';
import location from './modules/location';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        location,
    },
});